import script from "./FacebookAdsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FacebookAdsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__